import pagelogin from 'v%/login.vue'
import pagetklogin from 'v%/tklogin.vue'
import pageapage from 'v%/apage.vue'
import pagelogout from 'v%/logout.vue'
import pageforgotpwd from 'v%/forgotpwd.vue'
import pageregister from 'v%/register.vue'
import pagesignup from 'v%/public/signup.vue'

import pagewxtoken from 'v%/wxtoken.vue'
import pagecomment from 'v%/public/comment.vue'
import pagescomment from 'v%/public/scomment.vue'
import pagescomment2 from 'v%/public/scomment2.vue'
import pagefp from 'v%/public/filepackage.vue'
import pagesq from 'v%/public/situation.vue'
import pageteacherintroduce from 'v%/public/teacher-introduce.vue'
import pagecontrastdetail from 'v%/public/contrast-detail.vue'
import pagelessonmap from 'v%/public/lesson-map.vue'
import pagerecommend from 'v%/public/recommend.vue'
import pagenewsdetail from 'v%/public/news-detail.vue'
import pageappforgetpwd from 'v%/public/appforgetpwd.vue'

export default {
	pagelogin,
	pagetklogin,
	pageapage,
	pagelogout,
	pageforgotpwd,
	pageregister,
	pagecomment,
	pagescomment,
	pagescomment2,
	pagesignup,
	pagefp,
	pagesq,
	pagerecommend,
	pagelessonmap,
	pageteacherintroduce,
	pagecontrastdetail,
	pagenewsdetail,
	pageappforgetpwd,
	layout:(r)=>require(['v%/layout.vue'], r),
	
	//home
	home_index:(r)=>require(['v%/home/index.vue'],r),
	home_home:(r)=>require(['v%/home/home.vue'],r),
	home_attendances:(r)=>require(['v%/home/attendances.vue'],r),
	home_attendances_detail:(r)=>require(['v%/home/attendances/detail.vue'],r),
	home_schedules:(r)=>require(['v%/home/schedules.vue'],r),	
	home_schedule_detail:(r)=>require(['v%/home/schedule/detail.vue'],r),
	home_news:(r)=>require(['v%/home/news.vue'],r),
	home_reviews:(r)=>require(['v%/home/reviews.vue'],r),
	home_reviews_share:(r)=>require(['v%/home/reviews/share.vue'],r),
	home_homework:(r)=>require(['v%/home/homework.vue'],r),
	home_homework_detail:(r)=>require(['v%/home/homework/detail.vue'],r),
	home_homecomplete_detail:(r)=>require(['v%/home/homecomplete/detail.vue'],r),
	home_homework_submit:(r)=>require(['v%/home/homework/submit.vue'],r),
	home_artwork:(r)=>require(['v%/home/artwork.vue'],r),
	home_artwork_detail:(r)=>require(['v%/home/artwork/detail.vue'],r),
	home_prepare:(r)=>require(['v%/home/prepare.vue'],r),
	home_prepare_detail:(r)=>require(['v%/home/prepare/detail.vue'],r),
	home_book:(r)=>require(['v%/home/book.vue'],r),
	home_book_detail:(r)=>require(['v%/home/book/detail.vue'],r),
	home_book_center:(r)=>require(['v%/home/book/center.vue'],r),
    home_scores:(r)=>require(['v%/home/scores.vue'],r),
    home_scores_detail:(r)=>require(['v%/home/scores/detail.vue'],r),
	
	//lesson
	lesson_index:(r)=>require(['v%/lesson/index.vue'],r),
	lesson_lesson:(r)=>require(['v%/lesson/lesson.vue'],r),
	lesson_class:(r)=>require(['v%/lesson/class.vue'],r),
	lesson_mylesson:(r)=>require(['v%/lesson/mylesson.vue'],r),
	lesson_appointment:(r)=>require(['v%/lesson/appointment.vue'],r),
	lesson_appointment2:(r)=>require(['v%/lesson/appointment2.vue'],r),
	lesson_add_appointment:(r)=>require(['v%/lesson/add-appointment.vue'],r),
	
	//growth
	growth_index:(r)=>require(['v%/growth/index.vue'],r),
	growth_growth:(r)=>require(['v%/growth/growth.vue'],r),
	growth_contrast:(r)=>require(['v%/growth/contrast.vue'],r),
	growth_file_record:(r)=>require(['v%/growth/file-record.vue'],r),
	growth_service:(r)=>require(['v%/growth/service.vue'],r),
	growth_service_detail:(r)=>require(['v%/growth/service/detail.vue'],r),
	growth_growth_archive:(r)=>require(['v%/growth/growth-archive.vue'],r),
	
	//my
	my_index:(r)=>require(['v%/my/index.vue'],r),
	my_my:(r)=>require(['v%/my/my.vue'],r),
	my_archives:(r)=>require(['v%/my/archives.vue'],r),
	my_facereg:(r)=>require(['v%/my/facereg.vue'],r),
	my_add:(r)=>require(['v%/my/add.vue'],r),
	my_message:(r)=>require(['v%/my/message.vue'],r),
	my_score:(r)=>require(['v%/my/score.vue'],r),
	my_wallet:(r)=>require(['v%/my/wallet.vue'],r),
	my_credit:(r)=>require(['v%/my/credit.vue'],r),
	my_orders:(r)=>require(['v%/my/orders.vue'],r),
	my_order_detail:(r)=>require(['v%/my/order/detail.vue'],r),
	my_payments:(r)=>require(['v%/my/payments.vue'],r),
	my_complaints:(r)=>require(['v%/my/complaints.vue'],r),
	my_complaints_record:(r)=>require(['v%/my/complaints-record.vue'],r),
	my_setting:(r)=>require(['v%/my/setting.vue'],r),
	my_recommend_form:(r)=>require(['v%/my/recommend-form.vue'],r),
	my_recommend_record:(r)=>require(['v%/my/recommend-record.vue'],r),
	my_card:(r)=>require(['v%/my/card.vue'],r),
	my_card_detail:(r)=>require(['v%/my/card/detail.vue'],r),
    my_card_history:(r)=>require(['v%/my/card/history.vue'],r),
    my_media:(r)=>require(['v%/my/media.vue'],r),
}


// WEBPACK FOOTER //
// ./src/vuefiles.js